import { Badge } from 'cpool-components/general/Badge';

import { cn } from '~/utils/cnTailwind';

interface CountBadgeProps {
    count: number;
    className?: string;
}

export const CountBadge: React.FC<CountBadgeProps> = ({ className, count }) => {
    return (
        <Badge
            className={cn(
                'flex items-center justify-center rounded-md p-4 text-lg border-none h-10 aspect-square',
                className,
            )}
        >
            {count}
        </Badge>
    );
};
